module.exports = __webpack_public_path__ + "static/media/netto.61368a6d.png";